import './CreditCardIbanSale.scss';

// @ vendors
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';

// @ actions
import { getIbanBankEntities } from 'actions/optionsActions';
import { resetIban } from 'actions/ibanActions';
import { error } from 'ok-iban/dist/actions/OKIban';
import { ibanValidationActionCall } from 'actions/ibanActions';
import { showPreLoader, hidePreLoader } from 'actions/preLoaderActions';

// @ constants
import { COUNTRY_CODE_ES } from 'commonsConstants/countryCodes';
import { IBAN, VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { SUCCESS_STATUS, WAITING_STATUS } from 'constants/pollingConstants';
import { CREDIT_CARD_TAG, PATH_CREDIT_CARD } from 'constants/uTagConstants/paths';
import { EVENT_ONBOARDING, EVENT_VALID_IBAN } from 'constants/uTagConstants/RAConstants';
import { ERROR_AL_VALIDAR_IBAN_FORMATO, ERROR_AL_VALIDAR_IBAN_ENTIDAD } from 'constants/analyticsErrors';
import { CREDIT_CARD } from 'constants/userProfile';

// @ components
import { OKIban } from 'ok-iban/dist/components/OKIban/OKIban';

// @utilities
import { checkConditionAndExecuteCallback } from 'utilities/toggling';
import { checkAndCreateAttrbIfExistsIn, getUserProfileData } from 'utilities/userProfile';
import { PAGE_PRODUCT, recordEvent, RELIABLE } from 'utilities/uTagging';
import { BANKIA_CODE, OPENBANK_CODE } from '../../../constants/iban';

// @ commons
import { FormattedText, formatText } from 'core/i18n';

class CreditCardIbanSale extends PureComponent {
    state = {
        identityMethod: {
            [IBAN]: false,
            [VIDEO_CALL]: false,
            [VIDEO_SELFIE]: false,
        },
        ibanInserted: '',
        isIbanAlreadyInserted: false,
        ibanErrorType: '',
        isIbanValid: false,
    };

    UNSAFE_componentWillMount() {
        const { handleDisableNextButton, userProfile } = this.props;

        userProfile.identityMethod === IBAN ? handleDisableNextButton(false) : handleDisableNextButton(true);

        const TRUE_USER_IDENTITY_METHOD = checkAndCreateAttrbIfExistsIn(userProfile.identityMethod, {
            IBAN,
            VIDEO_CALL,
            VIDEO_SELFIE,
        });
        this.setState({ identityMethod: { ...TRUE_USER_IDENTITY_METHOD } });
    }

    componentDidUpdate() {
        const { immIban, ibanPollingStatus } = this.props;
        const { isIbanAlreadyInserted, ibanInserted } = this.state;

        const iban = immIban.get('iban');
        const ibanInStoreAndIbanInsertedAreEqual = ibanInserted === iban;

        if (isIbanAlreadyInserted && ibanInStoreAndIbanInsertedAreEqual) return;

        this.checkForIbanOnlineStatusAndResetLocalIban(ibanPollingStatus);
        const ibanHasNoErrors = immIban.get('error') === '';
        const isSpainIban = iban !== '' && iban.substring(0, 2) === COUNTRY_CODE_ES;

        checkConditionAndExecuteCallback(isSpainIban && ibanHasNoErrors && !ibanInStoreAndIbanInsertedAreEqual, () =>
            this.storeInsertedIban(iban)
        );
    }

    checkForIbanOnlineStatusAndResetLocalIban = status => {
        if (status !== SUCCESS_STATUS || status !== WAITING_STATUS) this.setState({ ibanInserted: '' });
    };

    storeInsertedIban = iban => {
        const { handleDisableNextButton } = this.props;
        handleDisableNextButton(false);
        this.recordIbanValidationEvent();
        this.setState(() => ({
            ibanInserted: iban,
            isIbanAlreadyInserted: true,
        }));
    };

    recordIbanValidationEvent = () => {
        const { isIbanValid } = this.state;

        checkConditionAndExecuteCallback(isIbanValid, () => {
            this.recordIdentityIbanTagging({
                eventTag: 'validacion por iban correcto - ' + formatText(isIbanValid),
                customProcessEventTag: EVENT_VALID_IBAN,
            });
        });
    };

    onHandleValidationError = errorValue => {
        const { resetIban, setInternalIbanError } = this.props;

        checkConditionAndExecuteCallback(errorValue === 'validation-ibanFormatError', () => {
            resetIban();
            setTimeout(() => setInternalIbanError('validation-ibanFormatError'), 300);
            this.recordIdentityIbanTagging({
                eventTag: 'validacion por iban incorrecto - ' + formatText(errorValue),
                customProcessEventTag: ERROR_AL_VALIDAR_IBAN_FORMATO,
            });
        });

        checkConditionAndExecuteCallback(errorValue === 'validation-ibanEntityError', () => {
            resetIban();
            setTimeout(() => setInternalIbanError('validation-ibanEntityError'), 300);
            this.recordIdentityIbanTagging({
                eventTag: 'validacion por iban incorrecto / entidad' + formatText(errorValue),
                customProcessEventTag: ERROR_AL_VALIDAR_IBAN_ENTIDAD,
            });
        });
    };

    onHandleValidOrInvalidIban = (valid, type = '') => {
        const {
            immIban,
            userProfile: { accessToken },
            ibanValidationActionCall,
            setInternalIbanError,
            showPreLoader,
            hidePreLoader,
        } = this.props;

        this.setState({ isIbanValid: valid, ibanErrorType: type });

        const iban = immIban.get('iban');
        if (valid) {
            const isSpainIban = iban !== '' && iban.substring(0, 2) === COUNTRY_CODE_ES;
            showPreLoader();

            if (!isSpainIban) {
                resetIban();
                setTimeout(() => {
                    setInternalIbanError('validation-ibanFormatError');
                    hidePreLoader();
                }, 300);
                return;
            }

            setTimeout(() => {
                ibanValidationActionCall(accessToken, iban).then(response => {
                    if (response.status === 'OK') ibanValidationActionCall(accessToken, iban, CREDIT_CARD).then();
                    hidePreLoader();
                });
            }, 500);
        }
    };

    recordIdentityIbanTagging = ({ eventTag, customProcessEventTag }) => {
        const { encryptedDocNumber, recordId, userId, investmentType } = getUserProfileData(this.props);
        recordEvent(
            PATH_CREDIT_CARD,
            PAGE_PRODUCT,
            'validacion por iban',
            eventTag,
            recordId,
            userId,
            RELIABLE[this.props.userProfile.identityMethod],
            investmentType,
            encryptedDocNumber,
            { categoriaEvento: EVENT_ONBOARDING, accionEvento: CREDIT_CARD_TAG, etiquetaEvento: customProcessEventTag }
        );
    };

    render = () => {
        return (
            <section className="iban-credit-sale-rectange row">
                <div className="margin-container">
                    <div className="title-credit-sale">
                        <FormattedText value="creditCardOffer-iban" />
                    </div>

                    <div className="small-credit-sale-title">
                        <FormattedText value="creditCardOffer-ownerAccount" />
                    </div>

                    <div className="iban-text-credit-sale">
                        <FormattedText value="creditCardOffer-ibanNumber" />
                    </div>
                    <div className="small-credit-sale-iban-tittle">
                        <FormattedText value="creditCardOffer-ibanNumberDestiny" />
                    </div>
                    <div className="small-credit-sale-iban-tittle">
                        <FormattedText value="creditCardOffer-copyReminder" />
                    </div>

                    <Form model="userProfile" className="iban-credit-sale-form">
                        <OKIban
                            errorEntity="validation-ibanEntityError"
                            errorFormat="validation-ibanFormatError"
                            placeholder={formatText('creditCardOffer-ibanInputPlaceholder')}
                            disabled={false}
                            handleValidationError={this.onHandleValidationError}
                            eventRecoding={this.onHandleValidOrInvalidIban}
                            withImmediateValidation={true}
                            errorCountry="validation-ibanCountryValidation"
                            validCountries={[COUNTRY_CODE_ES]}
                            notAllowedEntities={[
                                { code: OPENBANK_CODE, errorMessage: 'validation-preValidationIbanOpen' },
                            ]}
                        />
                    </Form>
                    <div className="small-credit-sale-iban-tittle terms-and-conditions-iban-sale ">
                        <FormattedText value="creditCardOffer-termsAndConditions" />
                    </div>
                </div>
            </section>
        );
    };
}

export default connect(
    state => ({
        userProfile: state.userProfile,
        options: state.options,
        immIban: state.iban,
    }),
    {
        getIbanBankEntities,
        resetIban,
        setInternalIbanError: error,
        ibanValidationActionCall,
        showPreLoader,
        hidePreLoader,
    }
)(CreditCardIbanSale);
